// Toast service that can be used anywhere in the app, including in providers
// This works by dispatching custom events that the ToastProvider listens to

export interface ToastOptions {
  title: string;
  message?: string;
  duration?: number;
  type: 'success' | 'error' | 'warning' | 'info' | 'loading';
}

class ToastService {
  private dispatch(options: ToastOptions) {
    // Dispatch a custom event that ToastProvider can listen to
    window.dispatchEvent(new CustomEvent('toast-service', {
      detail: options
    }));
  }

  success(title: string, message?: string) {
    this.dispatch({ type: 'success', title, message });
  }

  error(title: string, message?: string) {
    this.dispatch({ type: 'error', title, message });
  }

  warning(title: string, message?: string) {
    this.dispatch({ type: 'warning', title, message });
  }

  info(title: string, message?: string) {
    this.dispatch({ type: 'info', title, message });
  }

  loading(title: string, message?: string) {
    this.dispatch({ type: 'loading', title, message });
  }
}

export const toastService = new ToastService();